import {
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  FormFeedback,
} from "reactstrap";
import { useRef, useState } from "react";
import axios from "axios";

import { Elements, useElements, useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "../../CheckoutForm";
import Button from "../../../Buttons/Button";
 const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY);
const SummaryStep = ({ data, total,clientSecret }) => {
 const paymentRef = useRef();
   const handlePayNow = () => {
    paymentRef.current?.submitPayment();
  };
  return (
    <div className="checkout-content">
      <Row>
        <Col md={12}>
           {clientSecret && (
        <div>
          <Elements
            stripe={stripePromise}
            options={{
              clientSecret,
              appearance: {
                theme: "stripe",
              },
            }}
          >
            <CheckoutForm ref={paymentRef}/>
          </Elements>
        </div>
      )}
        </Col>

        
      </Row>

      <div className="price-summary">
        <h3>Summary</h3>

        <div className="price-row">
          <span>Name</span>
          <span>{data.billing?.name}</span>
        </div>

        <div className="price-row">
          <span>Address</span>
          <span>{data.billing?.address}</span>
        </div>

        <div className="price-row">
          <span>City</span>
          <span>{data.billing?.city}</span>
        </div>

        <div className="divider" />

        <div className="price-total">
          <span>Total</span>
          {/* <strong>${total}</strong> */}
           <strong>${total.toFixed(2)}</strong>
        </div>


<Button
          onClick={handlePayNow}
          disabled={!clientSecret}
          text="Pay now"
          className="next-btn mt-4"
        />

      </div>


     
    </div>
  );
};

export default SummaryStep;